import { createContext, useContext, type RefObject } from 'react'

export interface FrameScrollContextValue {
  scrollContainerRef: RefObject<HTMLDivElement | null>
  /**
   * Nested scrollports (e.g. MessageList) call this so Frame can show the
   * topnav shadow when the Frame content container itself is not scrolling.
   */
  reportNestedScrolled: (isScrolled: boolean) => void
}

const FrameScrollContext = createContext<FrameScrollContextValue | null>(null)

export const FrameScrollProvider = FrameScrollContext.Provider

/** @returns Frame content scroll container ref, or null outside Frame. */
export const useFrameScrollRef = (): RefObject<HTMLDivElement | null> | null => {
  return useContext(FrameScrollContext)?.scrollContainerRef ?? null
}

/** @returns Nested-scroll reporter, or null outside Frame. */
export const useReportFrameNestedScroll = (): ((isScrolled: boolean) => void) | null => {
  return useContext(FrameScrollContext)?.reportNestedScrolled ?? null
}
